import script from "./IndexView.vue?vue&type=script&setup=true&lang=js"
export * from "./IndexView.vue?vue&type=script&setup=true&lang=js"

import "./IndexView.vue?vue&type=style&index=0&id=07201bbb&scoped=true&lang=css"

import exportComponent from "F:\\MUZI\\com-muzimuzi-saas\\muzi-saas-admin-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07201bbb"]])

export default __exports__